// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1_i5y","empty":"ModalGraph_empty__2kcR4"};